import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type MoneyBagFillProps = IconComponentBaseProps;

export const MoneyBagFill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: MoneyBagFillProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_10823_78034"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10823_78034)">
        <path
          d="M9.9985 13.1169C9.58392 13.1169 9.22947 12.9693 8.93517 12.674C8.64072 12.3787 8.4935 12.0238 8.4935 11.6092C8.4935 11.1945 8.64114 10.84 8.93642 10.5456C9.2317 10.2513 9.5867 10.1042 10.0014 10.1042C10.416 10.1042 10.7704 10.2518 11.0648 10.5471C11.3592 10.8424 11.5064 11.1974 11.5064 11.6121C11.5064 12.0267 11.3588 12.3811 11.0635 12.6754C10.7682 12.9697 10.4132 13.1169 9.9985 13.1169ZM6.56246 6.14585H13.4375L14.5 4.00481C14.6282 3.75384 14.6204 3.50974 14.4766 3.27252C14.333 3.0353 14.1175 2.91669 13.83 2.91669H6.16996C5.88246 2.91669 5.6669 3.0353 5.52329 3.27252C5.37954 3.50974 5.37177 3.75384 5.49996 4.00481L6.56246 6.14585ZM7.09621 17.0834H12.9037C14.0647 17.0834 15.0516 16.6787 15.8643 15.8694C16.677 15.0601 17.0833 14.0706 17.0833 12.9011C17.0833 12.4127 16.9997 11.9372 16.8325 11.4746C16.6652 11.0118 16.4257 10.5925 16.1137 10.2165L13.7627 7.39585H6.23725L3.88621 10.2165C3.57426 10.5925 3.33468 11.0118 3.16746 11.4746C3.00024 11.9372 2.91663 12.4127 2.91663 12.9011C2.91663 14.0706 3.32128 15.0601 4.13058 15.8694C4.93989 16.6787 5.92843 17.0834 7.09621 17.0834Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
